module.exports = __webpack_public_path__ + "static/media/cbc-fashions.399bc42e.png";